import { IDENTITY_IMAGE_MAX_DIMENSION, IDENTITY_IMAGE_MAX_PIXELS, IDENTITY_IMAGE_MAX_SIZE_BYTES, IDENTITY_IMAGE_OUTPUT_MIME_TYPE, identityImageMimeTypeSchema } from "./identity-image.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/organization-logo.ts
const ORGANIZATION_LOGO_MAX_SIZE_BYTES = IDENTITY_IMAGE_MAX_SIZE_BYTES;
const ORGANIZATION_LOGO_MAX_DIMENSION = IDENTITY_IMAGE_MAX_DIMENSION;
const ORGANIZATION_LOGO_MAX_PIXELS = IDENTITY_IMAGE_MAX_PIXELS;
const ORGANIZATION_LOGO_OUTPUT_SIZE = 512;
const ORGANIZATION_LOGO_OUTPUT_MIME_TYPE = IDENTITY_IMAGE_OUTPUT_MIME_TYPE;
const ORGANIZATION_LOGO_ROUTE = "/v1/organizations/current/logo";
const ORGANIZATION_LOGO_PUBLIC_ROUTE_PREFIX = "/v1/organization-logos";
const organizationLogoMimeTypeSchema = identityImageMimeTypeSchema;
const organizationLogoOrganizationIdSchema = z$1.string().trim().min(1).max(255).regex(/^[a-zA-Z0-9_-]+$/u);
const organizationLogoAssetIdSchema = z$1.uuid();
const organizationLogoStoredUrlSchema = z$1.string().trim().min(1).max(2048);
const organizationLogoReferenceSchema = z$1.strictObject({
	assetId: organizationLogoAssetIdSchema,
	url: z$1.url().max(2048)
});
const organizationLogoPrepareRpcInputSchema = z$1.strictObject({
	actorUserId: z$1.string().trim().min(1).max(255),
	organizationId: organizationLogoOrganizationIdSchema
});
const organizationLogoCommitRpcInputSchema = z$1.strictObject({
	actorUserId: z$1.string().trim().min(1).max(255),
	expectedLogo: organizationLogoStoredUrlSchema.nullable(),
	nextLogo: organizationLogoReferenceSchema.nullable(),
	organizationId: organizationLogoOrganizationIdSchema
});
const organizationLogoMutationErrorCodeSchema = z$1.enum([
	"organization.logo.conflict",
	"organization.logo.forbidden",
	"organization.logo.internal_error",
	"organization.logo.invalid_input",
	"organization.logo.invalid_reference",
	"organization.logo.metadata_invalid",
	"organization.logo.not_found",
	"organization.logo.personal_unsupported"
]);
const organizationLogoMutationFailureSchema = z$1.strictObject({
	code: organizationLogoMutationErrorCodeSchema,
	message: z$1.string().trim().min(1),
	ok: z$1.literal(false)
});
const organizationLogoPrepareRpcResponseSchema = z$1.discriminatedUnion("ok", [z$1.strictObject({
	currentLogo: organizationLogoStoredUrlSchema.nullable(),
	ok: z$1.literal(true)
}), organizationLogoMutationFailureSchema]);
const organizationLogoCommitRpcResponseSchema = z$1.discriminatedUnion("ok", [z$1.strictObject({
	logo: z$1.url().max(2048).nullable(),
	ok: z$1.literal(true)
}), organizationLogoMutationFailureSchema]);
const organizationLogoResponseSchema = z$1.strictObject({
	logo: z$1.url().max(2048).nullable(),
	ok: z$1.literal(true)
});
function buildOrganizationLogoObjectKey(input) {
	const parsed = parseOrganizationLogoAddress(input);
	return `organizations/${parsed.organizationId}/logos/${parsed.assetId}.webp`;
}
function buildOrganizationLogoPublicPath(input) {
	const parsed = parseOrganizationLogoAddress(input);
	return `${ORGANIZATION_LOGO_PUBLIC_ROUTE_PREFIX}/${encodeURIComponent(parsed.organizationId)}/${parsed.assetId}.webp`;
}
function parseOrganizationLogoReferenceFromUrl(value) {
	if (typeof value !== "string" || value.length > 2048) return null;
	let url;
	try {
		url = new URL(value);
	} catch {
		return null;
	}
	if (url.protocol !== "https:" && url.protocol !== "http:" || url.search.length > 0 || url.hash.length > 0) return null;
	const prefix = `${ORGANIZATION_LOGO_PUBLIC_ROUTE_PREFIX}/`;
	if (!url.pathname.startsWith(prefix)) return null;
	const segments = url.pathname.slice(prefix.length).split("/");
	if (segments.length !== 2) return null;
	let organizationId;
	try {
		organizationId = decodeURIComponent(segments[0] ?? "");
	} catch {
		return null;
	}
	const fileName = segments[1] ?? "";
	if (!fileName.endsWith(".webp")) return null;
	const parsed = z$1.strictObject({
		assetId: organizationLogoAssetIdSchema,
		organizationId: organizationLogoOrganizationIdSchema
	}).safeParse({
		assetId: fileName.slice(0, -5),
		organizationId
	});
	return parsed.success ? parsed.data : null;
}
function parseOrganizationLogoAddress(input) {
	return z$1.strictObject({
		assetId: organizationLogoAssetIdSchema,
		organizationId: organizationLogoOrganizationIdSchema
	}).parse(input);
}
//#endregion
export { ORGANIZATION_LOGO_MAX_DIMENSION, ORGANIZATION_LOGO_MAX_PIXELS, ORGANIZATION_LOGO_MAX_SIZE_BYTES, ORGANIZATION_LOGO_OUTPUT_MIME_TYPE, ORGANIZATION_LOGO_OUTPUT_SIZE, ORGANIZATION_LOGO_PUBLIC_ROUTE_PREFIX, ORGANIZATION_LOGO_ROUTE, buildOrganizationLogoObjectKey, buildOrganizationLogoPublicPath, organizationLogoAssetIdSchema, organizationLogoCommitRpcInputSchema, organizationLogoCommitRpcResponseSchema, organizationLogoMimeTypeSchema, organizationLogoMutationErrorCodeSchema, organizationLogoOrganizationIdSchema, organizationLogoPrepareRpcInputSchema, organizationLogoPrepareRpcResponseSchema, organizationLogoReferenceSchema, organizationLogoResponseSchema, organizationLogoStoredUrlSchema, parseOrganizationLogoReferenceFromUrl };

//# sourceMappingURL=organization-logo.js.map